export default __webpack_public_path__ + "static/media/GustavDustParticleBackRight.9362ce5a.png";